import React, { useState, forwardRef } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import PropTypes from 'prop-types';

const AsyncTypeaheadInput = forwardRef(function AsyncTypeaheadInput({ multiSelections, setMultiSelections, searchURI }, ref) {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleSearch = (query) => {
    setIsLoading(true);

    fetch(`${searchURI}?q=${query}&per_page=50`)
      .then((resp) => resp.json())
      .then(({ data }) => {
        setOptions(data);
        setIsLoading(false);
      });
  };

  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  return (
    <AsyncTypeahead
      ref={ref}
      delay={500}
      filterBy={filterBy}
      id="messenger-input"
      isLoading={isLoading}
      labelKey="display_name"
      minLength={3}
      onSearch={handleSearch}
      onChange={setMultiSelections}
      selected={multiSelections}
      multiple
      options={options}
      placeholder="Type a name or multiple names"
      renderMenuItemChildren={(option) => (
        <>
          <img
            alt={option.display_name}
            src={option.headshot_url}
            style={{
              height: '24px',
              marginRight: '10px',
              width: '24px',
            }}
          />
          <span>{option.display_name}</span>
        </>
      )}
    />
  );
});

AsyncTypeaheadInput.propTypes = {
  multiSelections: PropTypes.array.isRequired,
  setMultiSelections: PropTypes.func.isRequired,
  searchURI: PropTypes.string.isRequired
}

export default AsyncTypeaheadInput;
